// extracted by mini-css-extract-plugin
export default {"wrapper":"BoardsPageHeader_wrapper__2NYUu","title":"BoardsPageHeader_title__50UET"};